import { createFileRoute } from "@tanstack/react-router";
import ResetPassword from "@/pages/ResetPassword";

export const Route = createFileRoute("/reset-password")({
  head: () => ({
    meta: [
      { title: "Wachtwoord herstellen | De Hussel App" },
      { name: "description", content: "Stel een nieuw wachtwoord in voor je Hussel App-account." },
      { property: "og:title", content: "Wachtwoord herstellen | De Hussel App" },
      { property: "og:description", content: "Stel een nieuw wachtwoord in voor je Hussel App-account." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ResetPassword,
});
